import axios from 'axios';
import baseService from '../shared/baseService';

const organogramService = (clientId: number) => baseService(`clients/${clientId}/organograms`);

const organogramGetAll = (clientId: number, treeList: boolean) => 
    axios.get(`clients/${clientId}/organograms?treeList=${treeList}`);

export default { 
    organogramService,
    organogramGetAll
};

